import React, { useState, useEffect } from 'react';

import _ from 'lodash';
import { Divider, Spinner, Typography } from '@telus-uds/components-web';

import {
  getContentfulData,
  contentfulFormConfig,
  getData
} from '../../contentful';
import request, { isAdmin, isSalesSupport } from '../../utils/request';

import { ContentWrapper } from '../../design/css';
import { getPathVariables } from '../../misc';
import { useLocalizedStringsContext } from '../../context/LocalizedStringsContext';

import Table from './Table';
import Pagination from './Pagination';

const ContactCentreSalesRepDashboard = () => {
  const localizedStrings = useLocalizedStringsContext();
  const {
    srtDashboard: { noOrders }
  } = localizedStrings;
  const locale = getPathVariables(window.location.pathname)[0];
  const config = {
    ...contentfulFormConfig,
    content_type: 'salesRepDashboard',
    locale
  };

  const [pageLayout, setPageLayout] = useState();
  const [ordersList, setOrdersList] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [pageLoading, setPageLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);

  const fetchOrders = () => {
    request
      .get(
        `/orders?type=CC&status=${
          isAdmin ? 'Submitted' : 'incomplete&status=Submitted'
        }&pageNumber=${pageNumber}&pageSize=${_.get(
          pageLayout,
          'ordersPerPage',
          10
        )}${isSalesSupport ? `&saleSupport=true` : ''}`
      )
      .then(response => {
        setOrdersList(_.get(response, 'data.results', []));
        setTotalOrders(_.get(response, 'data.totalCount', 0));
        setPageLoading(false);
      })
      .catch(() => {});
  };

  useEffect(() => {
    getContentfulData(config).then(res => {
      setPageLayout(getData(res));
      fetchOrders();
    });
  }, []);

  useEffect(() => {
    fetchOrders();
  }, [pageNumber]);

  return (
    <>
    <Divider space={2} variant={{ inverse: true }} />
      <ContentWrapper>
        {pageLoading && <Spinner show label="Loading Orders..." />}
        {!pageLoading && ordersList.length === 0 ? (
          <Typography heading="h3" variant={{ size: 'h3' }} block>{noOrders}</Typography>
        ) : (
          <>
            {!pageLoading && (
              <div className="table-container-main">
                <Table
                  pageLayout={pageLayout}
                  data={ordersList}
                  fetchOrders={fetchOrders}
                  totalOrders={totalOrders}
                />
                <Pagination
                  ordersPerPage={_.get(pageLayout, 'ordersPerPage', 10)}
                  totalOrders={totalOrders}
                  pageNumber={pageNumber}
                  setPageNumber={setPageNumber}
                />
              </div>
            )}
          </>
        )}
      </ContentWrapper>
    </>
  );
};

export default ContactCentreSalesRepDashboard;
